import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { catchError, switchMap, filter, take, tap, finalize } from "rxjs/operators";
import { Observable, throwError, BehaviorSubject } from "rxjs";
import { Router } from "@angular/router";

import Swal from "sweetalert2";
import { errorDialog, loadingDialog, successDialog } from "src/app/shared/dialog";
import { UserService } from "src/app/auth/service/user/user.service";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  constructor(
    private auth: UserService,

    private router: Router
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let authReq = request;
    const token = this.auth.getAcessToken();
    if (token != null) {
      authReq = this.addToken(request, token);
    }

    // Show loading if request takes longer than 1 seconds
    let checkInterval: any;
    loadingDialog();

    return next.handle(authReq).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          return this.handle401Error(authReq, next);
        } else {
          if (error instanceof HttpErrorResponse) {
            errorDialog(error.error?.error);
          }
          return throwError(() => error);
        }
      }),
      tap((event) => {
        if (event instanceof HttpResponse && request.method === "POST") {
          const responseMessage = event.body?.ok || "Operation successful!";

          setTimeout(() => {
            successDialog(responseMessage);
          }, 100);
        }
      }),
      finalize(() => {
        if (Swal.isLoading()) {
          Swal.close();
        }
      })
    );
  }
  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.auth.refreshToken().pipe(
        switchMap((tokenResponse: any) => {
          this.isRefreshing = false;
          const newToken = tokenResponse.accessToken;
          this.auth.setAccessToken(newToken);
          this.refreshTokenSubject.next(newToken);
          return next.handle(this.addToken(request, newToken));
        }),
        catchError((error: any) => {
          this.logoutAndNavigateToProfile();
          this.router.navigate(["/login"]);
          return throwError(error);
        })
      );
    } else {
      return this.refreshTokenSubject.pipe(
        filter((token) => token != null),
        take(1),
        switchMap((jwt) => {
          return next.handle(this.addToken(request, jwt));
        })
      );
    }
  }

  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  private logoutAndNavigateToProfile(): void {
    if (this.auth.isUserLogin()) {
      this.auth.logoutFromGoogleAccount();
    }
  }
}
